import { Component } from '@angular/core';
import { NavController,LoadingController } from 'ionic-angular';
import { Http, Response } from '@angular/http';
import { Storage } from '@ionic/storage';

//service
import { AppSharedService  } from '../service/app_shared'
import { UserService  } from '../service/user_service';

//page
import { MenuPage } from '../menu/menu'
import { TabsPage } from '../tabs/tabs'

//types
import { FilterTypeViewmodel,LoginInfo } from '../model/types';

@Component({
  selector: 'page-category',
  templateUrl: 'category.html',
})

export class CategoryPage {
  
  constructor(public navCtrl: NavController
             ,public appSharedService: AppSharedService
             ,private userService: UserService
             ,private http : Http
             ,private loadingCtrl : LoadingController
             ,public storage: Storage
  ) {

    //con-start
      if(this.userService.filterList != undefined 
        && this.userService.filterList !=null 
        && this.userService.filterList.categoryList !=undefined
        && this.userService.filterList.categoryList !=null 
        && this.userService.filterList.categoryList.length>0){

        }
        else
        {
          this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {
            if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){             
              this.getFilterList(userinfo.LocationId);
            }
          });
        }
    //con-end
  }

  //filter product start
  filterProduct(categoryId:number
              ,subCategoryId:number
              ,brandId:number
              ,productTypeId:number
              ,vendorId:number){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(TabsPage,
                                  {
                                    categoryId:categoryId,
                                    subCategoryId:subCategoryId,
                                    brandId:brandId,
                                    productTypeId:productTypeId,
                                    vendorId:vendorId
                                  }
                        );
    }

  // filter product end


  // go to home-start
    goToHome(){
      this.navCtrl.popToRoot();
      this.navCtrl.setRoot(MenuPage)
    }
  // go to home end

  // function - get fileter list -start
  getFilterList(LocationId:number){
         
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
  
  //show loader
  loading.present();

    var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath
            +'/'
            +this.appSharedService.configInfo.urlInfo.urlGetFilterType
            +LocationId);
    
    // get banner
    this.http.get(url)
        .map((data : Response) =>{
                return data.json() as FilterTypeViewmodel;
            }).toPromise().then(x => {                  
              // assign response variable                              
          this.userService.filterList=x;
              loading.dismiss();
     });
    }
    // function - get fileter list - end

    
    //reset filter-start
    resetFilter(){
      this.navCtrl.popToRoot();
      this.navCtrl.setRoot(TabsPage,
                                    {
                                      categoryId:0,
                                      subCategoryId:0,
                                      brandId:0,
                                      productTypeId:0,
                                      vendorId:0
                                    }
                           );
          }
    //reset filter-end

  }



// WEBPACK FOOTER //
// ./src/pages/category/category.ts